// Core
import ROUTES from "@constants/routing";
import MainView from "@views/MainView/MainView";
import { createBrowserRouter } from "react-router-dom";
export const router = createBrowserRouter([
  {
    path: ROUTES.CHATBOT,
    element: <MainView />
  },
]);
